import React from "react";

import { T } from "services/lang/LanguageService";
import {
  IProductTemplateAttribute,
  Validation,
} from "components/dashboard/product-template-table/utils/interfaces";
import { InputText } from "primereact/inputtext";
import { CellType } from "utils/enums";
import ValidationOptions from "./components/ValidationOptions";

type ForeignKeyTypeProps = {
  attribute: IProductTemplateAttribute;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onValidationChange: (validations: Validation[]) => void;
};

const ForeignKeyType: React.FC<ForeignKeyTypeProps> = ({ attribute, onChange, onValidationChange }) => {
  return (
    <>
      <div className="p-field p-col-6">
        <label>{T("word.foreign-template")}</label>
        <InputText
          placeholder="Foreign template"
          value={attribute.foreignTemplate ?? ""}
          onChange={onChange}
          name="foreignTemplate"
          className="p-inputtext-sm"
        />
      </div>
      <ValidationOptions
        cellType={CellType.FOREIGN_KEY}
        validators={attribute.validationOptions?.validators ?? []}
        onValidationChange={onValidationChange}
      />
    </>
  );
};

export default ForeignKeyType;
